module.exports = __webpack_public_path__ + "static/assets/17fa2153b40451b3b76beaac8f5d313b.svg";